import React from 'react';
import { ArrowRight, Edit, ProductSummaryElement } from '@adac-mp/components';
import { IOffer, IOrderInfoDetails, IProductSummary } from '@adac-mp/shared';

export const renderProductSummaryElement = (productSummary: IProductSummary[], offer: IOrderInfoDetails | IOffer) => {
	const getIcon = (type: string | undefined, index) => {
		switch (type) {
			case 'edit':
				return <Edit id={`editIcon-${index}`} />;
			case 'trips':
				return <ArrowRight strokeWidth="1" />;
			default:
				return undefined;
		}
	};
	return (
		<>
			{productSummary?.map((item, index) => (
				<ProductSummaryElement
					key={index}
					id={item.id}
					wrap={item.id === 'dates'}
					data-cy={`product-${index}-${item.type ?? 'info'}`}
					role="button"
					type={item.type}
					label={item.label}
					value={item.value}
					editable={item.editable}
					hidden={item.hidden}
					tracking={item.tracking}
					icon={getIcon(item.type, index)}
					hasErrors={item.hasErrors}
					submitTracking={item.submitTracking}
					submitButtonLabel={item.submitButtonLabel}
					cancelButtonLabel={item.cancelButtonLabel}
					onClick={item.handleOnClick}
					onChange={() => item.handleChange && item.handleChange()}
					onClose={(modalParentRef) => {
						if (modalParentRef?.current) {
							modalParentRef.current.focus();
						}
						if (item.handleClose) {
							item.handleClose();
						}
					}}>
					{offer ? item.component : undefined}
				</ProductSummaryElement>
			))}
		</>
	);
};
